import { APPLICATION_ROUTES } from '@translations/features/application/config/routes.config';

export const getLoginUrl = (): string => {
  return `${window.location.origin}${APPLICATION_ROUTES.LOGIN}`;
};
